import React, { useState } from 'react';
import '../App.css';
import { Alert } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function UserOTP() {
  const [otpInput, setOtpInput] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.email || '';
  const authToken = `${process.env.REACT_APP_BASE_AUTHKEY}`;

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleVerifyOtp = async () => {
    if (!otpInput) {
      setErrorMessage('Please enter OTP');
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post(
        'https://api.japaking.online/api/otp/verify',
        { otp: otpInput },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response?.data?.success === true) {
        navigate('/password-change', { state: { email } });
      } else {
        setErrorMessage('Invalid OTP. Please try again.');
      }
    } catch (error) {
      setErrorMessage('An error occurred while verifying OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    if (!email) {
      setErrorMessage('Email missing. Please go back and try again.');
      return;
    }

    setResendLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.post('https://api.japaking.online/api/otp/send', {
        email,
      });

      if (response?.data?.success) {
        setErrorMessage('OTP has been resent. Please check your email.');
      } else {
        setErrorMessage('Failed to resend OTP. Please try again.');
      }
    } catch (error) {
      setErrorMessage('An error occurred while resending OTP. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="login-v2-page">
      <div className="login-v2-card">
        <button type="button" className="login-v2-back" onClick={handleGoBack}>
          Back
        </button>

        <h1 className="login-v2-title">Email Verification</h1>
        <p className="login-v2-subtitle">Enter the OTP sent to your email</p>

        <div className="login-v2-field-block">
          <label className="login-v2-label">Email</label>
          <input className="login-v2-input" value={email} disabled />
        </div>

        <div className="login-v2-field-block">
          <label className="login-v2-label">OTP Code</label>
          <input
            className="login-v2-input"
            placeholder="Enter OTP code"
            onChange={(e) => setOtpInput(e.target.value)}
            value={otpInput}
          />
        </div>

        {errorMessage && (
          <Alert variant={errorMessage.includes('resent') ? 'success' : 'danger'} className="mt-2">
            {errorMessage}
          </Alert>
        )}

        <button className="login-v2-button" onClick={handleVerifyOtp} disabled={!otpInput || loading}>
          {loading ? 'Verifying...' : 'Confirm'}
        </button>

        <button
          className="login-v2-button login-v2-secondary-button"
          onClick={handleResendOTP}
          disabled={resendLoading || !email}
        >
          {resendLoading ? 'Resending...' : 'Resend OTP'}
        </button>
      </div>
    </div>
  );
}

export default UserOTP;
